import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const solutions = [{
  title: "Are you a business looking for qualified candidates?",
  description: "Find qualified candidates for your caregiving business",
  items: ["expand the services you offer", "ensure you meet your clients' needs", "save time finding and retaining quality paid caregiving staff", "access upskilling options to improve retention"],
  cta: "Get Started",
  link: "#"
}, {
  title: "Are you looking for meaningful flexible work?",
  description: "Learn about caregiving work opportunities",
  items: ["explore meaningful, flexible work offers", "have a positive impact on your community", "discover health care career pathways in caregiving", "connect with upskilling opportunities"],
  cta: "Get Started",
  link: "#"
}];
export default function WorkforceSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="53551" id="find-the-services-workforce-solution-that-meets-your-needs" ref={ref} className={`dark bg-[#04052F] text-foreground py-24 px-4 md:px-8 lg:px-16 transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-[32px] font-bold text-white leading-tight tracking-tight">
            Find the services workforce solution that meets your needs
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {solutions.map((solution, i) => <Card key={i} data-index={i} className="bg-[#090834] border-none shadow-[0px_10px_30px_rgba(0,0,0,0.5)] rounded-xl flex flex-col h-full">
              <CardHeader className="p-8 md:p-12 pb-4 md:pb-6 space-y-4">
                <CardTitle className="text-2xl md:text-[24px] font-bold text-white leading-snug tracking-tight">
                  {solution.title}
                </CardTitle>
                <CardDescription className="text-base md:text-[16px] text-[#A9A9A9] font-normal">
                  {solution.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="p-8 md:p-12 pt-0 flex-grow">
                <ul className="space-y-4">
                  {solution.items.map((item, idx) => <li key={idx} data-index={idx} className="flex items-start gap-3">
                      <div className="mt-1 shrink-0 bg-[#2EA3D2] rounded-full p-0.5">
                        <Check className="w-4 h-4 text-white" />
                      </div>
                      <span className="text-[#A9A9A9] text-[16px] leading-relaxed">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </CardContent>
              <CardFooter className="p-8 md:p-12 pt-0">
                <Button asChild className="w-full rounded-full bg-linear-to-r from-[#5A40C0] to-[#2EA3D2] hover:opacity-90 hover:shadow-[0_0_20px_rgba(46,163,210,0.3)] transition-all duration-300 h-auto py-4 text-[16px] font-semibold text-white border-0 shadow-md cursor-pointer">
                  <Link to={solution.link}>{solution.cta}</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}